module.exports = __webpack_public_path__ + "img/Mask Group.2cc0d404.png";